<select id="informationSourceId"
  name="informationSourceId"
  class="form-control"
  [(ngModel)]="informationSourceId"
  (change)="informationSourceChanged()">
  <option value=""></option>
  <option *ngFor="let informationSource of informationSources"
    [value]="informationSource.id"
    [selected]="informationSource.id === informationSourceId">{{ informationSource.name }}</option>
  <option value="-1">&hellip; {{ 'registration_informationSource_customText' | l10n }}</option>
</select>
<div [hidden]="informationSourceId != -1" class="customText">
  <input type="text" #informationSourceCustomText id="informationSource_customText" name="informationSource_customText"
    class="form-control" [(ngModel)]="value"
    [placeholder]="'registration_informationSource_customText_placeholder' | l10n">
</div>
